class DelegatedCardRowController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  openModalDelegatedRequest() {
    let event = this.EventEmitter({
      employee: this.currentEmployee,
    });
    this.processEmployee(event);
  }

}

export default DelegatedCardRowController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/delegatedCardRow.controller.js